import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { useArchitectLinks } from '../../../context/ArchitectLinksContext';
import InfoModal from '../../modals/InfoModal';

export function DesignerTag({ name, className }) {
  const { getArchitectSlug } = useArchitectLinks();
  const slug = getArchitectSlug(name);
  if (slug) {
    return (
      <Link
        to={`/lists/architects/${slug}`}
        className={`${className} hover:underline`}
      >
        {name}
      </Link>
    );
  }
  return <span className={className}>{name}</span>;
}

function GolfCourseDesign({ course }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <section className="mx-auto w-full mt-1">
      <article
        id="golfCourseDesign"
        className="xl:min-h-[225px] rounded-xl bg-white shadow-lg gap-y-4 w-full prose prose-sm max-w-none sm:prose-md text-left"
      >
        {/* Designer Section */}

        <div className="pl-6  grid grid-rows-[4rem,6rem] lg:grid-rows-1">
          {/* Left Column */}
          <div className="grid grid-cols-2">
            {course.opened_date ? (
              <div>
                <h3 className="text-sm font-semibold text-gray-700">
                  Course Open Year:
                </h3>
                <span className="inline-block bg-green-100 text-green-800 text-xs font-medium py-1 px-3 rounded-full">
                  {course.opened_date}
                </span>
              </div>
            ) : (
              <div>
                <h3 className="text-sm font-semibold text-gray-700">
                  Course Open Year:
                </h3>
                <span className="inline-block bg-green-100 text-green-800 text-xs font-medium py-1 px-3 rounded-full">
                  Unknown
                </span>
              </div>
            )}

            {(course.designer_original_1 || course.designer_original_2) && (
              <div>
                <h3 className="text-sm font-semibold text-gray-700 truncate">
                  Original Architect:
                </h3>
                {course.designer_original_1 ? (
                  <DesignerTag
                    name={course.designer_original_1}
                    className="inline-block bg-pink-100 text-pink-600 text-xs font-medium py-1 px-3 rounded-full mr-2 mb-[1px]"
                  />
                ) : (
                  <span className="inline-block bg-pink-100 text-pink-600 text-xs font-medium py-1 px-3 rounded-full mr-2 mb-[1px]">
                    Unknown
                  </span>
                )}
                {course.designer_original_2 && (
                  <DesignerTag
                    name={course.designer_original_2}
                    className="inline-block bg-pink-100 text-pink-600 text-xs font-medium py-1 px-3 rounded-full"
                  />
                )}
              </div>
            )}
          </div>

          {/* Bottom Row */}
          <div>
            <h3 className="text-sm font-semibold text-gray-700">
              Contributor(s):
            </h3>
            <div>
              {course.designer_contributor &&
              course.designer_contributor.length > 0 ? (
                <>
                  {/* Display first 1 contributors on small screens */}
                  {course.designer_contributor
                    .slice(0, 1)
                    .map((contributor, index) => (
                      <DesignerTag
                        key={index}
                        name={contributor}
                        className="sm:hidden inline-block bg-blue-100 text-blue-600 text-xs font-medium py-1 px-3 rounded-full"
                      />
                    ))}

                  {/* Display "..." on small screens only if there are more than 1 contributors */}
                  {course.designer_contributor.length > 1 && (
                    <p
                      className="sm:hidden inline-block bg-blue-100 text-blue-600 text-xs font-medium py-1 px-3 rounded-full cursor-pointer"
                      onClick={() => setIsModalOpen(true)}
                    >
                      ...
                    </p>
                  )}

                  {/* Display all contributors on larger screens */}
                  {course.designer_contributor.map((contributor, index) => (
                    <DesignerTag
                      key={index}
                      name={contributor}
                      className="hidden sm:inline-block bg-blue-100 text-blue-600 text-xs font-medium py-1 px-3 rounded-full mr-1"
                    />
                  ))}
                </>
              ) : (
                <p className="inline-block bg-blue-100 text-blue-600 text-xs font-medium py-1 px-3 rounded-full">
                  Unknown
                </p>
              )}
            </div>
          </div>
        </div>

        {/* Modal for showing all contributors */}
        <InfoModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          title="Course Design Contributors"
        >
          {course.designer_contributor &&
            course.designer_contributor.map((contributor, index) => (
              <DesignerTag
                key={index}
                name={contributor}
                className="block w-fit p-[3px] text-xs font-thin text-blue-600 bg-blue-100 rounded-md my-[1px]"
              />
            ))}
        </InfoModal>
      </article>
    </section>
  );
}

export default GolfCourseDesign;
